import { InputData } from "../input/InputData";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { PHPResponse } from "../PHPResponse";
import { CartEntryListResponse } from "./CartEntryListResponse";

export class CartListInput extends InputData
{
  wishlist:boolean;
}
